import React from "react"

import Img from "gatsby-image"
import "./index.css"
import "../style/font-style.css"
import { Box, TextField, Grid } from "@material-ui/core"
import AOS from "aos"
import "aos/dist/aos.css"
import { useStaticQuery, graphql, Link } from "gatsby"
import Head from "../components/head"
import Header from "../components/Header_normal"
import RecentNews from "../components/RecentNews"
import Profile from "../components/Profile"
import Media from "../components/Media"
import Content from "../components/content"
import Footer from "../components/footer"
import Pastevent from "../components/pastevent"
import { Hidden } from "@material-ui/core"
import { ContactForm } from "../components/ContactForm"

export default function Home() {
  if (typeof document !== `undefined`) {
    AOS.init({
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      delay: 600, // values from 0 to 3000, with step 50ms
      duration: 1000, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: false,
      anchorPlacement: "bottom-bottom",
    })
  }
  const data = useStaticQuery(graphql`
    query {
      cta: file(relativePath: { eq: "cta.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      scroll_cta: file(relativePath: { eq: "scroll_cta_button.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      scroll_cta_call: file(relativePath: { eq: "scroll_cta_call.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic1: file(relativePath: { eq: "pic1.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic2: file(relativePath: { eq: "pic2.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic3: file(relativePath: { eq: "pic3.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic4: file(relativePath: { eq: "pic4.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic5: file(relativePath: { eq: "pic5.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic6: file(relativePath: { eq: "pic6.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic7: file(relativePath: { eq: "pic7.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic8_1: file(relativePath: { eq: "pic8_1.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic8_2: file(relativePath: { eq: "pic8_2.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic9: file(relativePath: { eq: "pic9.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic10: file(relativePath: { eq: "pic10.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic11: file(relativePath: { eq: "pic11.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pic12: file(relativePath: { eq: "fotter.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <Head />
      <Box
        position="fixed"
        bottom="0"
        width="100%"
        maxWidth="450px"
        bgcolor="rgba(0,0,0,0.5)"
        left="0"
        right="0"
        m={"auto"}
        display="flex"
        borderRadius="4px"
        zIndex="99"
      >
        <Box width="32%" mt={1} mb={2}>
          <a href="tel:0234689011">
            <Img fluid={data.scroll_cta_call.childImageSharp.fluid} />
          </a>
        </Box>

        <Box width="68%" mt={1} mb={2}>
          <a href="/#contacts">
            <Img fluid={data.scroll_cta.childImageSharp.fluid} />
          </a>
        </Box>
      </Box>
      <Box width="100%" maxWidth="450px" m={"auto"} bgcolor="white">
        <Box position="relative" width="100%">
          <Img fluid={data.pic1.childImageSharp.fluid} />
          <Box
            position="absolute"
            right={0}
            left={0}
            bottom={"0px"}
            width="80%"
            maxWidth="450px"
            zIndex={1}
            margin={"auto"}
          >
            <iframe
              width="100%"
              height="auto"
              src="https://www.youtube.com/embed/CLp7TliolKU??playsinline=1"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            {/* <Link to="/#contacts">
              <Img fluid={data.cta.childImageSharp.fluid} />
            </Link> */}
          </Box>
        </Box>
        <Img fluid={data.pic2.childImageSharp.fluid} />
        <Box position="relative" width="100%">
          <Img fluid={data.pic3.childImageSharp.fluid} />
          <Box
            position="absolute"
            right={0}
            left={0}
            bottom={"33%"}
            width="80%"
            maxWidth="350px"
            zIndex={1}
            margin={"auto"}
          >
            <Link to="/#contacts">
              <Img fluid={data.cta.childImageSharp.fluid} />
            </Link>
          </Box>
        </Box>
        <Img fluid={data.pic4.childImageSharp.fluid} />
        <Img fluid={data.pic5.childImageSharp.fluid} />
        <Img fluid={data.pic6.childImageSharp.fluid} />
        <Img fluid={data.pic7.childImageSharp.fluid} />
        <Img fluid={data.pic8_1.childImageSharp.fluid} />
        <Img fluid={data.pic8_2.childImageSharp.fluid} />
        <Img fluid={data.pic9.childImageSharp.fluid} />
        <Img fluid={data.pic10.childImageSharp.fluid} />
        <Img fluid={data.pic11.childImageSharp.fluid} />
        <Box id="contacts" width="90%" m={"auto"}>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSfBsotWy7UfaW84sb6l5eZpgUGXsrZTY07PeouOgcH-ffOM9A/viewform?embedded=true"
            width="100%"
            height="1400px"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            読み込んでいます…
          </iframe>
        </Box>
        <Img
          fluid={data.pic12.childImageSharp.fluid}
          style={{ marginBottom: "128px" }}
        />
      </Box>
    </>
  )
}
